import BaseOverlayMenu from '../../sisu/overlay/BaseOverlayMenu.sisu';

export default BaseOverlayMenu;